import { Platform, Notify } from 'quasar'
import AssignmentsService from 'src/services/assignments'
import { useOccurrencesStore } from 'src/stores/index.js'
import { i18n } from 'src/boot/i18n'

export default {
  getAssignedForms (options) {
    const promise = AssignmentsService.getAssignedForms()

    promise.then(response => {
      if (!Platform.is.mobile && options === true) {
        response.forms = response.forms.filter(form => form.geofence === 0)
      }
      this.forms = response.forms
    })

    return promise
  },
  getLocationsForAssignment (options) {
    const promise = AssignmentsService.getLocationsForAssignment(options)

    promise.then(response => {
      this.locations = response.locations
    })

    return promise
  },
  getOccurrence (options) {
    const routineContext = options.is_routine_form ? {
      is_routine_form: options.is_routine_form,
      routine_event_id: options.routine_event_id,
      enforce_deadline: options.enforce_deadline,
      deadline_at_utc: options.deadline_at_utc
    } : null

    this.isOpeningOccurrence = true
    const occurrencesStore = useOccurrencesStore()
    occurrencesStore.setLoading(true)
    occurrencesStore.setCurrent(null)

    return AssignmentsService.getCurrentOccurrence(
      options.form_assignment_role_id,
      options.location_id,
      routineContext
    ).catch(error => {
      console.error(error)
      occurrencesStore.setLoading(false)
      Notify.create({
        type: 'negative',
        message: i18n.global.t(error?.response?.status === 403
          ? 'validations.occurrence_open_forbidden'
          : 'validations.occurrence_open_failed')
      })
      return {}
    }).then(data => {
      // Sin id de ocurrencia no hay quien navegue y apague el flag (Forms.vue lo apaga al
      // cambiar $route.fullPath) -> se quedaría prendido para siempre.
      if (!data?.occurrence?.id) this.isOpeningOccurrence = false
      return data
    })
  },
  assignmentEmailRol (payload) {
    const promise = AssignmentsService.assignmentEmailRol(payload)

    return promise
  },
  fetchAssignmentRoles (payload) {
    const promise = AssignmentsService.fetchAssignmentRoles(payload)

    promise.then(data => {
      this.assignmentsRoles = data
    })

    return promise
  },
  setSelectedForm (form) {
    this.selectedForm = form
  },
  setOpeningOccurrence (isOpening) {
    this.isOpeningOccurrence = isOpening
  },
  setSelectedBlock (block) {
    this.selectedBlock = block
    this.fillBlock = !!block
  },
  setLocationFilter (filter) {
    this.locationFilter = {
      folio: filter?.folio || '',
      locationIds: Array.isArray(filter?.locationIds) ? filter.locationIds : []
    }
  },
  clearLocationFilter () {
    this.locationFilter = { folio: '', locationIds: [] }
  }
}
